module.exports = __webpack_public_path__ + "img/机组工况.95124305.png";